export default "__VITE_ASSET__DVI_ZShN__"